import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import AuthProvider from "./utils/authProvider";
import oauth, { loadUserFromStorage } from "./_services/oauth";
import PrivateRoute from "./utils/protectedRoute";
import "bootstrap/dist/css/bootstrap.min.css";
// core components

//import Home from "layouts/Home.js";
import Signature from "layouts/Signature";
import SubSignature from "layouts/SubSignature";
import Signature2568 from "layouts/Signature2568";
import SubSignature2568 from "layouts/SubSignature2568";
import Signature2569 from "layouts/Signature2569";
import SubSignature2569 from "layouts/SubSignature2569";
import Home from "layouts/Home.js";

function App() {
  useEffect(() => {
    // fetch current user
    //loadUserFromStorage(store);
  }, []);

  return (
    <Provider store={store}>
      <AuthProvider userManager={oauth} store={store}>
        <Router>
          <Switch>

          <Route path="/home" component={Home} />
          <Route path="/signature" component={Signature} />
          <Route path="/subsignature" component={SubSignature} />
          <Route path="/signature2568" component={Signature2568} />
          <Route path="/subsignature2568" component={SubSignature2568} />
           <Route path="/signature2569" component={Signature2569} />
          <Route path="/subsignature2569" component={SubSignature2569} />

          <Redirect from="/" to="/home" />     

          </Switch>

        </Router>
      </AuthProvider>
    </Provider>
  );
}

export default App;
